import React, { useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { connect } from 'react-redux';
import Paragraph from '../Paragraph';
import { MercuryID } from '../../utils/Functions';
import Platforms from '../../data/Platforms';
import Master from '../Master';
import NoImage from '../../img/no-image.png';
import Collapsible from '../Panels/Collapsible';
import TenantsTable from './TenantsTable';
import UpdateProperty from './UpdateProperty';
import ModalButton from '../Buttons/ModalButton';

const readAuthUser = () => {
  if (typeof Storage === 'undefined') return null;
  try {
    return JSON.parse(window.localStorage.getItem('nyumbani'));
  } catch (e) {
    return null;
  }
};

const PropertyProfile = ({ location, user }) => {
  const isReadOnly = user && user.type === 'caretaker';
  const getInitialProperty = () => {
    if (location && location.property) return location.property;
    if (typeof Storage !== 'undefined') {
      const propStr = window.localStorage.getItem('property');
      if (propStr) {
        try {
          return JSON.parse(propStr);
        } catch (e) {
          return null;
        }
      }
    }
    return null;
  };

  const [property, setProperty] = useState(getInitialProperty());

  const authUser = readAuthUser();
  const token = authUser ? authUser.token : '';
  // UpdateProperty submits multipart/form-data (it appends an image File)
  const requestConfig = {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  };

  // After a successful edit, re-fetch the property so the profile reflects
  // the new details (and keep localStorage in sync for refreshes).
  const reloadProperty = async () => {
    if (!property || !property.id) return;
    try {
      const {
        data: { response },
      } = await axios.get(
        `${process.env.REACT_APP_API_URL}properties?where={"id":"${property.id}"}&take=1`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        },
      );
      const fresh = Array.isArray(response) ? response[0] : response;
      if (fresh) {
        // Keep any extra in-memory fields (e.g. occupancy) the list view
        // attached; let the freshly fetched values win for the rest.
        const merged = { ...property, ...fresh };
        setProperty(merged);
        if (typeof Storage !== 'undefined') {
          window.localStorage.setItem('property', JSON.stringify(merged));
        }
      }
    } catch (e) {
      // non-fatal — the edit still saved; the view just won't auto-refresh
    }
  };

  const paymentTitle = (id) => {
    return Platforms.find((item) => {
      return item.id === id;
    });
  };

  let imageLink = NoImage;
  if (property && property.images && property.images[0]) {
    imageLink = property.images[0].link;
  }

  return (
    <Master
      redirectLink="property"
      title="Property Management"
      source="Property"
    >
      {property ? (
        <>
          {!isReadOnly && (
            <div style={{ marginBottom: 10, textAlign: 'right' }}>
              <ModalButton
                caption="Edit Property"
                onClick={() => {}}
                modalId="propertyModal"
              />
            </div>
          )}
          <div className="row">
            <div className="col-xs-3 bm-responsive-div">
              <div className="row">
                <div className="col-md-12">
                  <img
                    className="bordered_photo"
                    style={{
                      width: '200px',
                      height: '200px',
                      margin: '5px',
                    }}
                    src={imageLink}
                    alt={property.name}
                  />
                </div>
              </div>
            </div>
            <div className="col-xs-9 bm-responsive-div">
              <div className="row">
                <Paragraph
                  columnWidth={12}
                  content={property.name}
                  caption="Property Name"
                />
              </div>
              <div className="row">
                <Paragraph
                  columnWidth={12}
                  content={property.description}
                  caption="Property Description"
                />
              </div>
              <div className="row">
                <Paragraph
                  columnWidth={12}
                  content={property.address}
                  caption="Property Address"
                />
              </div>
              {property.payment_details && (
                <div className="row">
                  {property.payment_details.map((payment) => {
                    return (
                      <>
                        {payment.payment_info && (
                          <>
                            <Paragraph
                              columnWidth={3}
                              key={MercuryID()}
                              content={
                                paymentTitle(payment.payment_info.platform).name
                              }
                              caption="Payment Platform"
                            />
                            <Paragraph
                              columnWidth={3}
                              key={MercuryID()}
                              content={payment.payment_info.account}
                              caption="Paybill Number"
                            />
                          </>
                        )}
                      </>
                    );
                  })}
                  <Paragraph
                    columnWidth={3}
                    content={property.units}
                    caption="Property Units"
                  />
                  <Paragraph
                    columnWidth={3}
                    content={property.status}
                    caption="Property Status"
                  />
                </div>
              )}
            </div>
          </div>
          <div className="row">
            <Collapsible
              columnWidth={12}
              caption="Tenants List"
              controlId="tList"
            >
              <TenantsTable property={property} />
            </Collapsible>
          </div>

          {/* Hidden edit modal — opened by the "Edit Property" button above.
              Reuses the same UpdateProperty modal as the Properties list. */}
          {!isReadOnly && (
            <UpdateProperty
              requestConfig={requestConfig}
              reLoadTable={reloadProperty}
              selectedProperty={property}
            />
          )}
        </>
      ) : null}
    </Master>
  );
};

PropertyProfile.propTypes = {
  location: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  user: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

PropertyProfile.defaultProps = {
  location: {},
  user: {},
};

const mapStateToProps = (state) => state;

export default connect(mapStateToProps)(PropertyProfile);
